<template>
    <b-modal @ok="submit" v-model="modalVisible"
                header-class="p-0"
                footer-class="d-flex justify-content-center border-0"
                content-class="custom-model-wrap"
                centered title="Set Officer"
                title-class="p-2"
                >
        <b-form submit.prevent="submit">
            <b-col md="6" cols="12">
                <label id="officer-input-group" for="officerInput" class="mb-4">
                    <strong>{{$translate('officer')}}</strong>
                </label>
                    <input
                        class="form-control custom-select"
                        id="officerInput"
                        name="officerInput"
                        v-model="driverId"
                        :options="driverOptions"
                        required
                    />
            </b-col>
        </b-form>
    </b-modal>
</template>
<template>
    <b-overlay :show="submitting" rounded="sm">
    <b-modal size="sm" @ok="submit" v-model="modalVisible" centered header-class="p-0"
        footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
        <template #modal-title>
            <div class="title-block text-center p-2">{{ $translate('set_officer') }}</div>
            <div class="close-btn" @click="cancel()">×</div>
        </template>
        <template #default>
            <b-form submit.prevent="submit">
                <b-col cols="12" class="dd">
                    <label id="officer-input-group" for="officerInput" class="mb-3">
                        <strong>{{ $translate('officer') }}</strong>
                    </label>
                    <b-form-select class="form-control" id="officerInput" name="officerInput" v-model="driverId"
                        :options="driverOptions" required>
                        <template #first>
                            <b-form-select-option :value="null">
                                {{ $translate('select_an_officer') }}
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-form>
        </template>
        <template #modal-footer="{ ok, cancel }">
            <div class="d-flex gap-2">
                <b-button variant="info" @click="ok()">{{ $translate('ok') }}</b-button>
                <b-button variant="info" @click="cancel()">{{ $cancelLabel() }}</b-button>
            </div>
        </template>
    </b-modal>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-changeDriver',
    props: ['orders'],
    mixins: [popupMixins, permissionsMixins],
    data: () => {
        return {
            modalVisible: false,
            driverId: null,
            submitting: false,
        }
    },
    computed: {
        driverOptions() {
            return this.drivers.map(x => ({
                value: x.id,
                text: `${x.first_name} ${x.last_name}`,
            }))
        },
        drivers() {
            return this.$store.state.orders.drivers
        },
    },
    watch: {
        drivers: function (drivers) {
            if (!this.driverId && drivers.length > 0)
                this.driverId = drivers[0].id
        },
    },
    created() { },
    methods: {
        show() {
            this.modalVisible = true
            this.driverId = null
        },
        close() {
            this.modalVisible = false
        },
        cancel() {
            this.modalVisible = false
        },
        async submit() {
            this.submitting = true
            await this.$store
                .dispatch('orders/bulkSetDriver', {
                    orders: this.orders,
                    driverId: this.driverId,
                })
                .then(() => {
                    this.doToast(
                        this.$translate('success'),
                        this.$translate('transfer_to_officer_successful'),
                        'success'
                    )

                    this.$emit('success')
                    this.modalVisible = false
                })
                .catch(err => {
                    console.error(err)
                    this.doToast(
                        this.$translate('error'),
                        this.$translate('transfer_to_officer_error'),
                        'danger'
                    )

                    this.$emit('error')
                    this.modalVisible = false
                })
                .finally(() => {
                    this.submitting = false
                })
        },
    },
    mounted() {
        this.$store.dispatch('orders/fetchDriversNew')
    },
}
</script>
